import { Link, Navigate, useNavigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../context/authContext";
import { AuthLayout } from "../components/Layouts/AuthLayout";
import { GoogleButton } from "../components/Buttons/GoogleButton";
import { FacebookButton } from "../components/Buttons/FacebookButton";
import { loginUserLocal } from "../api/auth";
import { Alert } from "../components/Alerts/Alert";
import { LoginForm } from "../components/Form/Forms/Auth/LoginForm";
import { motion } from "framer-motion";

export function Login() {
  const { state: authState, dispatch } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();

  if (authState.isAuthenticated) {
    const redirectPath = location.state?.path || "/dashboard";
    return <Navigate to={redirectPath} replace />;
  }

  const handleLocalLogin = (data) => loginUserLocal(data, dispatch, navigate);

  return (
    <AuthLayout>
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="w-full max-w-md bg-white/90 backdrop-blur-xl rounded-3xl p-10 border border-gray-200"
      >
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-900">
            Sign in to Shippal
          </h2>
          <p className="mt-2 text-sm text-gray-500">
            Enter your credentials to access your dashboard
          </p>
        </div>

        {authState?.error && (
          <div className="mt-4">
            <Alert message={authState.error} />
          </div>
        )}

        <div className="mt-8">
          <LoginForm
            onSubmit={handleLocalLogin}
            isLoading={authState?.isLoading}
          />
        </div>

        <div className="flex items-center my-6">
          <div className="flex-grow h-px bg-gray-200" />
          <span className="px-3 text-sm text-gray-400">or continue with</span>
          <div className="flex-grow h-px bg-gray-200" />
        </div>

        <div className="flex flex-col gap-3">
          <GoogleButton />
          <FacebookButton />
        </div>

        <p className="mt-8 text-center text-sm text-gray-600">
          New here?{" "}
          <Link to="/signup" className="text-blue font-medium hover:underline">
            Create an account
          </Link>
        </p>
      </motion.div>
    </AuthLayout>
  );
}
